export default function Logo() {
  return (
    <span className="logo">
      <img
        className="logo-full"
        src="/logo-full.png"
        alt="Hotel Gill Tower logo"
      />
    </span>
  );
}
